const ouvintes = new Set();
/**
 * Avisa os ouvintes **fora** da zona de transação do Dexie.
 *
 * O `setTimeout` não é folga estética. `gravar` avisa logo depois de a
 * transação cometer, e a própria chamada de `gravar` pode estar dentro de
 * uma transação maior (é o caso da troca de categoria do cronômetro, que
 * abre e fecha sessão numa transação só). Nos dois casos o código ainda roda
 * na zona (PSD) daquela transação: o Dexie a propaga pelas continuações de
 * promessa, microtarefas inclusive. Um ouvinte que leia dali uma tabela fora
 * do escopo da transação recebe `NotFoundError` — com o escopo
 * `['sessao', 'fila']` do cronômetro, ler `sessao` funciona e ler `pessoa`
 * rejeita. E é exatamente isso que `useConsultaCom` faz: registra a
 * releitura da tela como ouvinte, e toda tela montada relê a cada escrita.
 *
 * Um `setTimeout` de 0 é macrotarefa: sai da zona e do eco que o Dexie
 * mantém até esvaziar a fila de microtarefas. Alargar o escopo da transação
 * de quem escreve não resolveria nada — só mudaria qual tabela falta, porque
 * quem escreve não sabe (nem deve saber) o que as telas montadas leem.
 */
export function notificarMutacaoLocal() {
    setTimeout(() => {
        // A lista viva no momento do disparo, não uma cópia do momento do aviso:
        // uma tela desmontada entre um e outro cancelou a assinatura e não pode
        // ser chamada. A cópia rasa é só para o cancelamento de um ouvinte não
        // corromper a iteração dos outros.
        for (const o of [...ouvintes])
            o();
    }, 0);
}
export function aoMutarLocalmente(ouvinte) {
    ouvintes.add(ouvinte);
    return () => {
        ouvintes.delete(ouvinte);
    };
}
//# sourceMappingURL=sinalDeMutacao.js.map